import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { MessageCircle } from "lucide-react";
import { toast } from "sonner";

export function DelivererAccessButtons({ delivererId, phone }) {
  const { authAxios } = useAuth();
  const [sending, setSending] = useState(false);
  const [resending, setResending] = useState(false);

  const callSendAccess = async (forceExisting) => {
    const setLoading = forceExisting ? setResending : setSending;
    const confirmMsg = forceExisting
      ? `Reenviar acesso existente para ${phone || "este estafeta"}?`
      : `Enviar acesso por WhatsApp para ${phone || "este estafeta"}?`;
    if (!window.confirm(confirmMsg)) return;
    setLoading(true);
    try {
      const res = await authAxios.post(
        `/deliverers/${delivererId}/send-access-whatsapp?force_existing=${forceExisting}`
      );
      toast.success(
        res.data.token_generated
          ? "Acesso enviado. Token novo gerado e enviado por WhatsApp."
          : "Acesso enviado por WhatsApp com token existente."
      );
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Erro ao enviar WhatsApp");
    }
    setLoading(false);
  };

  return (
    <>
      <Button
        variant="outline" size="sm"
        className="h-7 px-2 text-xs gap-1 text-emerald-700 border-emerald-300 hover:bg-emerald-50"
        onClick={() => callSendAccess(false)}
        disabled={sending || resending}
        data-testid="send-access-wa-btn"
      >
        <MessageCircle className={`w-3 h-3 ${sending ? "animate-pulse" : ""}`} />
        {sending ? "A enviar…" : "Enviar acesso por WhatsApp"}
      </Button>
      <Button
        variant="ghost" size="sm"
        className="h-7 px-2 text-xs gap-1"
        onClick={() => callSendAccess(true)}
        disabled={sending || resending}
        data-testid="resend-access-wa-btn"
      >
        <MessageCircle className={`w-3 h-3 ${resending ? "animate-pulse" : ""}`} />
        {resending ? "A reenviar…" : "Reenviar acesso"}
      </Button>
    </>
  );
}
